module.exports = __webpack_public_path__ + "img/database.9cb486f8.jpg";